module.exports = __webpack_public_path__ + "static/media/booklogo-trans.c11dc7be.png";